let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cmcKh"), load("7Q0UC"), load("cjDIz")]).then(() => parcelRequire('1gsg0'));